import { AutoCompleteItemResolver } from '@ui/AutoCompleteField/types';
import BaseApiClient from '../BaseApiClient';
import { TypeInterface } from '@interfaces/Type.interface';
import { ListDataParams, ListDataResponse } from '@api-client/types';

export class ApiType extends BaseApiClient {
  /**
   * Get all items
   */
  async all(
    is_child_type: number,
    // beware, this arg is not companyId but, in fact, something along the lines of isNotCompany, values accepted by BE are 0 or null.
    //  DO NOT USE THIS ENDPOINT IT IS NOW DEPRECATED, use the types file one instead!!!!!
    company: number,
    listData?: ListDataParams
  ): Promise<Array<TypeInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(
          //  DO NOT USE THIS ENDPOINT IT IS NOW DEPRECATED, use the types file one instead!!!!!
          `/type?page[size]=999&is_child_type=${is_child_type}&company=${company}`,
          listData
        )
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async list(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<TypeInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.name = searchTerm;
      }
      this.client
        .getList('/get-types', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get a type
   */
  async get(id: number): Promise<TypeInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/type/${id}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  autoCompleteItemResolver: AutoCompleteItemResolver = async (value) => {
    const item = await this.get(Number(value));
    return {
      value: item.id,
      label: item.name
    };
  };

  /**
   * Store a type
   */
  async store(dto: {
    name: string;
    tenant_id?: number | null;
  }): Promise<TypeInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/type', dto)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { typeQueryKeys } from './query-keys';
export type { TypeListQueryParams } from './query-keys';
export { useTypeListQuery, useTypeQuery } from './use-type-queries';
export { useTypeStoreMutation, type TypeStoreVariables } from './use-type-mutations';

